// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__19wKN","Label":"BuildControl_Label__BV1Ts","Less":"BuildControl_Less__6SsVR","More":"BuildControl_More__3_rT3"};